<template>
  <change-password-component
    :error="error"
    :password="password"
    :passwordChanged="passwordChanged"
    :handlePasswordChange="handlePasswordChange"
    :handleChangeNewPassword="handleChangeNewPassword">
  </change-password-component>
</template>
<script>

import ChangePasswordComponent from '@/pages/change-password/ChangePasswordComponent';
export default {
  computed: {
    passwordChanged() {
      return this.$store.getters.getChangePasswordConfirmation;
    },
    password() {
      return this.$store.getters.getNewPassword;
    },
    error() {
      return this.$store.getters.getChangePasswordError;
    }
  },
  methods: {
    handleChangeNewPassword(value) {
      /* Action creator */
      this.$store.dispatch('changeFieldPasswordForm', value);
    },
    handlePasswordChange() {
      /* Request handler */ const password = {
        new_password1: this.password,
        new_password2: this.password
      };
      this.$store.dispatch('changePassword', password);

      if (this.$route.query.from) {
        const redirectPath = this.$route.query.from.split('?')[0];
        window.location = redirectPath;
      }
    }
  },
  components: {
    ChangePasswordComponent
  }
};
</script>
